<h2 mat-dialog-title>
    <ng-container *ngIf="txt == 'hugo_agence'">
        Comment réduire vos coûts de mise en location et de gestion ?
    </ng-container>
    <ng-container *ngIf="txt == 'hugo_pno'">
        Assurez votre bien dans les meilleurs conditions
    </ng-container>
    <ng-container *ngIf="txt == 'hugo_gli'">
        Vos loyers sont versés tous les mois quoi qu’il arrive !
    </ng-container>
    <i (click)="onCloseClick()" class="fa fa-close"></i>
</h2>
<div mat-dialog-content>
    <ng-container *ngIf="txt == 'hugo_agence'">
        LyBox a sélectionné pour vous la plate-forme de gestion locative la plus complète
        <a  target="_blank"  href="https://www.monsieurhugo.com/trouver-mon-locataire?partner=lybox">«Monsieur Hugo»</a> pour sécuriser
        vos investissements :
        <ul>
            <li><b>Vous gagnez du temps</b> car les tâches fastidieuses de la gestion ont été automatisées : envoi des
                quittances, prélèvement des loyers, tenu de la comptabilité, pré-bilan fiscal…
            </li>
            <li><b>Vous n’êtes plus seul pour gérer vos problèmes locatifs</b> : des experts comptables vous aident sur
                la
                fiscalité ; des juristes répondent à toutes vos questions, traitent vos litiges et s’occupent de vos
                impayés ; des artisans interviennent (sans frais) pour stopper les sinistres.
            </li>
            <li><b>Vous êtes mieux protégés</b> des risques locatifs avec un forfait tout compris 5 fois moins cher
                qu’en
                agence.
            </li>
        </ul>
        <p>En tant qu’utilisateur de LyBox, Monsieur Hugo <b>vous offre la certification</b> des dossiers de vos
            locataires.</p>
        <p>Si vous souhaitez trouver un locataire sérieux et solvable, commencez votre mise en location avec Monsieur
            Hugo.?</p>
    </ng-container>
    <ng-container *ngIf="txt == 'hugo_pno'">
        <p>LyBox a négocié pour vous la PNO la moins chère du marché à seulement 69€ par appartement donné en location.
            Elle est proposée par Monsieur Hugo (assureur Allianz).</p>
        <p>L’assurance PNO est obligatoire pour le bailleur : elle permet de vous protéger en cas de sinistre.</p>

        Les avantages de cette PNO :
        <ul>
            <li>Jusqu’à 12 800 000 € pour la responsabilité civile tous dommages confondus.</li>
            <li>Perte de loyer couvert jusqu’à 1 année pour les appartements et les maisons.</li>
            <li>Tarifs uniques et compétitifs pour les appartements et pour les maisons.</li>
            <li>Valeur de remplacement ou de reconstruction à neuf comme seuls plafonds de garantie.</li>
            <li>Un plafond à partir de 8 000 € pour la défense et les recours.</li>
            <li>Garantie dommages aux biens mobiliers : 5000€</li>
        </ul>
        Si vous souhaitez protéger au meilleur coût votre bien alors consultez le
        <a target="_blank" href="https://www.monsieurhugo.com/trouver-mon-locataire?partner=lybox">détail de cette assurance PNO</a>.
    </ng-container>
    <ng-container *ngIf="txt == 'hugo_gli'">
        <p>LyBox a négocié pour vous les meilleurs conditions pour votre garantie loyers impayés proposée par Monsieur
            Hugo (assureur Allianz).</p>

        En cas d’impayé, un juriste s’occupe de tout pour vous :
        <ul>
            <li>Il met en place la procédure à l’amiable</li>
            <li>Il lance la procédure judiciaire, finance les coûts d’huissiers, d’avocats, serruriers…</li>
            <li>Il pilote la procédure d’expulsion</li>
            <li>Vos impayés sont remboursés tous les mois : plafond de 70 000€ en durée illimitée et sans franchise</li>
            <li>En cas d’abandon du bien par le locataire : vos loyers sont remboursés jusqu’à récupération du bien</li>
            <li>En option, protégez vos meubles en cas de détérioration immobilière (plafond de 10 000€)</li>
        </ul>
        Si vous souhaitez augmenter votre rentabilité en bénéficiant <b>d’une remise de 26% sur votre GLI</b>, alors
        consultez le <a target="_blank" href="https://www.monsieurhugo.com/trouver-mon-locataire?partner=lybox">détail de cette garantie</a>.
    </ng-container>
</div>
<div mat-dialog-actions>
    <ng-container *ngIf="txt.includes('hugo')">
        <a type="button" href="https://www.monsieurhugo.com/trouver-mon-locataire?partner=lybox" target="_blank" class="btn btn-primary">
            Découvrez Monsieur Hugo
        </a>
    </ng-container>
</div>
